export const apiEndpoints = {
  users: {
    index: '/users',
  },
  categories: {
    index: '/categories',
  },
  documents: {
    index: '/documents',
    id: '/documents/{id}',
    publishPrivate: '/documents/{id}/private/publish',
    publishPublic: '/documents/{id}/public/publish',
    file: '/documents/{id}/file',
    tree: '/documents/{id}/tree',
    forget: '/documents/{id}/forget',
    reauthorize: '/documents/{id}/reauthorize',
    recipientsFile: '/documents/{id}/recipientsFile',
    documentsReportFile: '/documents/documentsReportFile',
    private: '/documents/private',
    public: '/documents/public',
  },
  recipients: {
    validity: '/recipients/validity',
  },
  utils: {
    hello: '/utils/hello',
    me: '/utils/me',
    refreshToken: '/utils/refreshToken',
    settings: '/utils/settings',
    login: '/utils/login',
    fullIdentityLogin: '/utils/fullIdentity/login',
    fullIdentityStatus: '/utils/fullIdentity/loginStatus/{taskId}',
  },
};
